import { Tabs, Tab } from 'components/tabs'
import { PageHeader } from 'components/page-header'
import { urlToTitle } from 'pages/pga-coach/activity-plans/lib/transformStage'
import useStyles from 'pages/pga-coach/activity-plans/stage'
import { Link, useLocation, useParams, useRouteMatch } from 'react-router-dom'
import ActivityPlansStageRoutes from 'routes/activity-plans-stage-routes'
import {
  ActivityPlanDetailHeaderProvider,
  useActivityPlanDetailHeader,
} from 'pages/pga-coach/activity-plans/activity-plan-detail-header-context'

const ActivityStageContent = () => {
  const { stage } = useParams()
  const match = useRouteMatch()
  const path = match.url
  const location = useLocation()
  const {
    detailTitle,
    detailSubtitle,
    actionsTarget,
  } = useActivityPlanDetailHeader()
  const isDetails =
    !location.pathname.endsWith('activities') &&
    !location.pathname.endsWith('plans')
  const styles = useStyles()

  const listPath = location.pathname
    .split('/')
    .slice(0, 4)
    .join('/')

  const crumbs = [
    {
      label: 'Activity',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
  ]

  const crumbsDetails = [
    {
      label: 'Activity Plans',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
    {
      label: urlToTitle(stage).title,
      to: listPath,
    },
  ]

  return (
    <>
      <PageHeader
        title={isDetails ? detailTitle || '' : urlToTitle(stage).title}
        subtitle={isDetails ? detailSubtitle : undefined}
        crumbs={isDetails ? crumbsDetails : crumbs}
        actions={isDetails ? actionsTarget : undefined}
        keepActionsInline={isDetails}
        fixedMobileActions={isDetails}
        tabs={
          <Tabs
            value={window.location.pathname}
            className={`${isDetails ? styles.hiddenTabs : ''}`}
          >
            <Tab
              label="Activities"
              value={`${path}/activities`}
              component={Link}
              to={`${path}/activities`}
            />
            <Tab
              label="Featured Plans"
              value={`${path}/plans`}
              component={Link}
              to={`${path}/plans`}
            />
          </Tabs>
        }
      />
      <ActivityPlansStageRoutes />
    </>
  )
}

const ActivityStage = () => (
  <ActivityPlanDetailHeaderProvider>
    <ActivityStageContent />
  </ActivityPlanDetailHeaderProvider>
)

export default ActivityStage
